import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

const legacyHomePage = () => dynamicImport(import('./legacy/home'))
const cmsHomePage = () => dynamicImport(import('./Home'))

export default ({ country, locale, config }) => {
  const { FF_NEW_URL_FORMAT, FF_CMS_HOME_PAGE_BY_COUNTRY } = config
  const useNewUrl = FF_NEW_URL_FORMAT.includes(country)
  const isCmsPageEnabledForCurrentCountry =
    FF_CMS_HOME_PAGE_BY_COUNTRY.includes(country)

  return [
    {
      path: useNewUrl ? `/:locale(${locale})` : '/',
      component: isCmsPageEnabledForCurrentCountry
        ? cmsHomePage
        : legacyHomePage,
      name: ROUTES.HOME,
    },
  ]
}
